import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-app-for-day-batch-heatmap',
    templateUrl: './app-for-day-batch-heatmap.component.html',
    styleUrls: ['./app-for-day-batch-heatmap.component.scss']
})
export class AppForDayBatchHeatmapComponent implements OnChanges {
    @Input() batchData: any;
    @Input() appForDay: any;

    appForBatchHeatmap: ApexOptions;

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.batchData && changes.batchData.currentValue &&
            changes.appForDay && changes.appForDay.currentValue) {
            this.appForBatchHeatmap = {
                series: [
                    {
                        name: this.batchData.labels[0],
                        data: this.generateData(this.batchData.ai.series, this.appForDay.labels)
                    },
                    {
                        name: this.batchData.labels[1],
                        data: this.generateData(this.batchData.aerospace.series, this.appForDay.labels)
                    },
                    {
                        name: this.batchData.labels[2],
                        data: this.generateData(this.batchData.climate.series, this.appForDay.labels)
                    },
                    {
                        name: this.batchData.labels[3],
                        data: this.generateData(this.batchData.adMan.series, this.appForDay.labels)
                    },
                    {
                        name: this.batchData.labels[4],
                        data: this.generateData(this.batchData.biotech.series, this.appForDay.labels)
                    },
                    {
                        name: this.batchData.labels[5],
                        data: this.generateData(this.batchData.quantum.series, this.appForDay.labels)
                    },
                ],
                chart: {
                    // height: 350,
                    type: "heatmap",
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    width: '100%',
                    height: '100%',
                    toolbar: {
                        show: true
                    },

                    zoom: {
                        enabled: false
                    }
                },
                xaxis: {
                    labels: {
                        format: 'dd MMM'
                    }
                },
                legend: {
                    show: true,
                    position: 'right'
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#fb2e00"],
                // title: {
                //     text: "HeatMap Chart (Single color)"
                // }
            }
        }
    }

    generateData(series, labels) {

        let res = series.map((s, index) => {
            return {
                x: labels[index],
                y: s
            }
        })

        return res;
    }
}
